// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1DFKF","options":"AnswerScale_options__3oAUi","selected":"AnswerScale_selected__36h-3"};